"use client";
import type { SelectOption } from "shared/SelectOption";
import SharedSelect, { type SelectProps } from "shared-web/components/form/Select/Select";
import { useExtracted } from "#i18n";

export type { SelectProps } from "shared-web/components/form/Select/Select";
export default function Select<O extends SelectOption>(props: SelectProps<O>) {
  const t = useExtracted();
  return (
    <SharedSelect
      {...props}
      placeholder={props.placeholder ?? t("Select an option")}
      noOptionsText={t("No results found")}
      loadingText={t("Loading options...")}
      clearLabel={props.clearLabel ?? t("Clear selection")}
    />
  );
}
